import { pipe, prop, toPairs } from 'ramda'

export const getErrorKey = pipe(
  toPairs,
  prop(0),
  ([key]) => key
)
